import React from "react"

const PaymentPolicy = () => {
  return (
    <div className="page">
      <h1 className="page-title">
        ETR Connect Advisor Information and Payment Policy
      </h1>
      <p>
        This ETR Connect Advisor Information and Payment Policy (the “Policy”)
        explains how Aptiviti, Inc. (“ETR” “we” and “us”) obtains, utilizes,
        shares and safeguards information collected from Advisors and visitors
        to its websites. By visiting our websites or by becoming a ETR Connect
        Advisor, you consent to the collection, use and transfer of your
        personal data pursuant to the terms of this Policy.
      </p>

      <h3>The Personal Data We Collect From You</h3>
      <p>
        ETR collects personal data that you choose to provide to us on the
        Websites, through email, over the phone and otherwise, including your
        name, contact information, work address, email address, phone number,
        and if you are a potential Advisor, we additionally collect home
        address, employment and biographical information, social security
        numbers, banking information, and payment preferences. In addition,
        ETR’s Websites may automatically record information when you visit. This
        information can include your Internet Protocol address and data
        concerning webpage requests.
      </p>

      <p>
        ETR may place small files called “cookies” on your computer when you
        visit the Websites. Cookies facilitate your utilization of the Websites
        and enable us to track activity and customize your website experience.
        If you do not wish to receive a cookie from ETR, you may set your
        Internet browser settings to decline or disable the cookie.
      </p>

      <h3>How Your Personal Data Is Used</h3>
      <p>
        We utilize personal data collected to match you with advisory
        opportunities, send calendar invites, and administer payment. We do not
        sell or share your personal data with third parties for their marketing
        or solicitation purposes. We do not use IP addresses or web page request
        information to try and identify you (nor do we disclose that information
        to third parties for them to use for their own purposes). ETR and
        trusted third parties utilize personal data only for the purposes for
        which it was obtained.
      </p>

      <h3>How Your Personal Data Is Disclosed</h3>
      <p>
        Personal data provided to ETR will be processed and stored by us inside
        the United States and will be accessed by our staff and third parties
        working for us for the purposes set forth in this Policy or for other
        purposes subject to your consent. ETR may share your personal data with
        our Clients, typically in connection with advisory opportunities (as
        this is one of the core and necessary functions provided by our
        platform). ETR may disclose the fact that you are an Advisor and
        personal data collected about you in response to a valid order or
        request by a court or other governmental body, to enforce an agreement
        between you and ETR or one of ETR’s Clients, to protect ETR’s rights, or
        as otherwise required by law, legal process or for the prevention or
        detection of a crime.
      </p>

      <h3>Updating Your Information</h3>
      <p>
        As one of the Terms & Conditions of your participation in ETR Connect,
        you are required to update the biographical and employment information
        you provide to ETR regularly. You are entitled to review the personal
        information ETR holds about you and may ask that we revise your personal
        information to ensure that it is current and correct. We may also revise
        your information using data obtained from third parties or public
        sources.
      </p>

      <h3>Payment to Advisors</h3>
      <p>
        When you agree to a consultation, you will have the option to confirm
        whether you wish to initiate a consultation at that price. For all
        completed consultations, you will be paid at your hourly rate, as
        charged in one (1) second intervals. Each time you complete a
        consultation, you will receive payments via the bank account associated
        with your account. Following completion of the transaction, you will
        receive an email receipt to the email you provided. You authorize ETR
        and its payments provider, as detailed below, to administer payment each
        time a transaction is completed. You represent and warrant to ETR that
        such information is true and that you are authorized to accept payment
        via the account provided. You will promptly update your account
        information with any changes that may occur. For detailed information on
        the amounts received in your account, please log in to your account to
        see your “Transaction History” tab in the “Payment” section of the menu.
      </p>
      <p>
        Payment Disputes and Refunds. You may dispute a transaction by clicking
        “Support” on the main screen or emailing us at connect@etr.ai. This
        action will result in ETR taking action to assist you in resolving the
        relevant payment dispute. Otherwise, you must notify ETR in writing
        within thirty (30) days of the transaction you wish to dispute. Failure
        to so notify ETR shall result in the waiver by you of any claim relating
        to such disputed payment. Payment shall be calculated solely based on
        records maintained by ETR. If you believe there has been a billing or
        accounting error, please contact us at connect@etr.ai.
      </p>

      <p>
        Stripe Additional Terms and Conditions. Payment processing services are
        provided by Stripe and subject to the Stripe Connected Account Agreement
        (available at{" "}
        <a
          href="https://stripe.com/us/connect-account/legal"
          rel="noreferrer"
          target="_blank"
        >
          https://stripe.com/us/connect-account/legal)
        </a>
        , which includes the Stripe Services Agreement (available at{" "}
        <a href="https://stripe.com/us/legal" rel="noreferrer" target="_blank">
          https://stripe.com/us/legal
        </a>{" "}
        ) (collectively, the "Stripe Terms"). By using ETR Connect to receive
        payment proceeds, you agree to be bound by the Stripe Terms, which may
        be modified from time to time. As a condition of ETR enabling payment
        processing services through Stripe, you authorize ETR to obtain all
        necessary access and perform all necessary activity on your Stripe
        Connected Account to facilitate your provision of services as
        contemplated by the Agreement and your relationship with ETR. You
        further agree to provide accurate and complete information about you,
        and authorize ETR to share it and transaction information with Stripe
        for the purposes of facilitating the payment processing services
        provided by Stripe. ETR reserves the right to switch payment processing
        vendors or use alternate or backup vendors in its discretion.
      </p>

      <h3>Phone Calls</h3>
      <p>
        Twilio Additional Terms and Conditions. If you call or text (SMS)
        message a user through the Service, ETR uses Twilio, Inc. (“Twilio”) to
        mask your telephone number. During this process, ETR and Twilio receive
        in real time and store call data, including the date and time of the
        call or text (SMS) message, the parties’ phone numbers, and the content
        of the call and text (SMS) messages. We share your telephone number and
        call data with Twilio so that Twilio can mask your telephone number.
        Twilio's privacy policy is available here.
      </p>

      <h3>Information Security</h3>
      <p>
        We use physical and technological security measures to protect your
        information both online and offline from unauthorized access and against
        illegal manipulation and processing, accidental loss and damage. We will
        preserve your information for a reasonable period of time or as required
        by law.
      </p>

      <h3>Opting Out</h3>
      <p>
        You may elect to opt-out of membership in ETR Connect at any time by
        providing ETR with written or electronic notice. Upon receipt of such
        notice, we will cease contacting you and cease presenting information
        concerning you to Clients for potential advisory opportunities.
      </p>

      <h3>Updates to the Policy</h3>
      <p>
        ETR may update this policy from time to time. To the extent permitted by
        law, any changes to our privacy policy will be posted to the Websites
        and will become effective upon posting. Your continued use of the
        Websites and failure to opt out of ETR Connect will indicate your
        agreement to such changes.
      </p>

      <h3>Contact ETR Connect</h3>
      <p>
        We welcome all requests, suggestions and questions concerning our use of
        your personal data. All such communication should be directed to{" "}
        <a href="mailto:connect@etr.ai">connect@etr.ai</a>
      </p>
    </div>
  )
}

export default PaymentPolicy
